// src/pages/About.js
import React from "react";
import {
  AboutPageContainer,
  AboutCard,
  AboutHeader,
  AboutTitle,
  AboutBody,
  Section,
  SectionTitle,
  P,
  CTARow,
  CTAButton,
  SecondaryButton,
  PortraitBlock,
  PortraitImg
} from "./AboutElements";
import {
  MobileInlineOnly
} from "../CommonElements";
import aboutPortrait from "../../images/About.jpg";


export default function About() {
  return (
    <AboutPageContainer>
      <AboutCard>
        <AboutHeader>
          <AboutTitle>Filmmaker, Drone Operator and Creative Lead</AboutTitle>
        </AboutHeader>

        <PortraitBlock>
          <PortraitImg src={aboutPortrait} alt="Maciek — portrait" />
        </PortraitBlock>

        <AboutBody>

          {/* ENGLISH SECTION */}
          <Section>
            <SectionTitle><MobileInlineOnly>🇬🇧</MobileInlineOnly> About</SectionTitle>
            <P>
            {`Hi, I’m Maciek and I’m a perfectionist. I do consider it one of my many flaws, but when it comes to the productions I work on, it actually comes in pretty handy.

            Perfectionism makes me focus on every, even the tiniest, detail. For me it’s not just moving images – it’s a story, one that together with the right soundtrack is meant to evoke exactly the emotions we planned for the audience.

            I put my whole self into what I do – whether I’m behind the camera or in post-production. Everyone who has worked with me knows I tend to spend way more time on a project than the average “video button-pusher.” The result? Premium quality that I stand firmly behind.

            If you’re looking to quickly throw together just another random “reel” for social media – we’re probably not a good fit. But if you want a video with a concept behind it, one that not only grabs attention but also truly impacts how your brand or product is perceived – then you’ve come to the right place.

            You can learn more about me in an interview I had the chance to give on Bristol FM Radio. Feel free to check it out.`}
            </P>

            {/* Optional CTAs (swap hrefs for real links) */}
            <CTARow>
              <CTAButton href="https://www.youtube.com/watch?v=lzcsNJVEA74" target="_blank" rel="noreferrer">
                ▶️ Interview: Bristol FM Radio
              </CTAButton>
              <SecondaryButton href="mailto:progressstudio.info@gmail.com">✉️ Email me</SecondaryButton>
              <SecondaryButton href="tel:+447736584565">📞 Call</SecondaryButton>
            </CTARow>
          </Section>
          {/* POLISH SECTION */}
          <Section>
            <SectionTitle><MobileInlineOnly>🇵🇱</MobileInlineOnly> O mnie</SectionTitle>
            <P>
            {`Cześć, jestem Maciek i jestem perfekcjonistą. Co prawda uważam to za jedną z wielu moich wad, ale akurat w produkcjach, którymi się zajmuję, bywa całkiem użyteczna.

            Perfekcjonizm sprawia, że zwracam uwagę na każdy, nawet najdrobniejszy detal. Dla mnie to nie tylko ruszające się obrazki, ale opowieść, która wraz z odpowiednio dobranym podkładem muzycznym ma wywołać u widza dokładnie takie emocje, jakie zaplanowaliśmy.

            Poświęcam całego siebie – zarówno kiedy stoję za kamerą, jak i podczas postprodukcji. Każdy, kto ze mną pracował, wie, że potrafię spędzić nad projektem dużo więcej czasu niż przeciętny „klepak” video. Efekt? Jakość premium, za którą stoję murem.

            Jeżeli jesteś osobą, która chce wrzucić na szybko byle jaką „rolkę” na social media – pewnie się nie dogadamy. Ale jeśli zależy Ci na klipie z pomysłem, który nie tylko przyciągnie uwagę, ale też realnie wpłynie na odbiór Twojej marki czy produktu – to trafiłeś w dobre miejsce.

            Jeżeli chcesz dowiedzieć się o mnie czegoś więcej to zapraszam do wysłuchania wywiadu dla Radia Bristol FM gdzie miałem okazję być gościem.`}
            </P>

            {/* Optional CTAs (swap hrefs for real links) */}
            <CTARow>
              <CTAButton href="https://www.youtube.com/watch?v=lzcsNJVEA74" target="_blank" rel="noreferrer">
                ▶️ Wywiad: Radio Bristol FM
              </CTAButton>
              <SecondaryButton href="mailto:progressstudio.info@gmail.com">✉️ Napisz do mnie</SecondaryButton>
              <SecondaryButton href="tel:+447736584565">📞 Zadzwoń</SecondaryButton>
            </CTARow>
          </Section>
        </AboutBody>
      </AboutCard>
    </AboutPageContainer>
  );
}
